import EventOrganizerFilter from "@/components/Events/EventOrganizerFilter/EventOrganizerFilter.vue";
import EventOrganizerListTable from "@/components/Events/EventOrganizerListTable/EventOrganizerListTable.vue";
import EventOrganizerEditDialog from "@/components/Events/EventOrganizerEditDialog/EventOrganizerEditDialog.vue";
import _ from "lodash";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import {
  createOpLoc,
  updateOpLoc,
  deleteOpLoc,
  defaultOpLoc
} from "@/helpers/opLocHelper";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "EventOrganizerList",
  props: ["editId"],
  data: () => ({
    filter: {
      page: 1,
      limit: 10,
      type: "all",
      cities: [],
      s: "",
      subPrincipals: []
    },
    headers: [
      {
        text: "Titel",
        align: "start",
        value: "title"
      },
      { text: "Kategorie", value: "type", sortable: false },
      { text: "Straße", value: "address.address" },
      { text: "PLZ", value: "address.zip" },
      { text: "Ort", value: "address.city" },
      { text: "Verknüpfte Veranstaltungen", value: "eventCount" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    showDialog: false,
    editedItem: {
      ...defaultOpLoc
    }
  }),
  async mounted() {
    await this.checkForOplocToEdit();
    await this.$store.dispatch("getOrganizerCities");
    await this.fetchData(this.filter, true);
  },
  methods: {
    createOpLoc,
    updateOpLoc,
    deleteOpLoc,
    async checkForOplocToEdit() {
      if (this.editId) {
        const oploc = await this.getSingleOploc(this.editId);
        this.editItem(oploc);
      }
    },
    async getSingleOploc(id) {
      if (id) {
        const headers = getTokenHeader();
        const principals = [
          this.$store.state.selectedPrincipal?.id,
          ...this.$store.state.selectedPrincipal?.subPrincipals?.map(
            subPrincipal => subPrincipal.id
          )
        ];
        const response = await axios.get(
          `${env.events_api_client_url}oploc/${id}`,
          {
            headers,
            params: { principal_id: principals }
          }
        );
        return response.data;
      }
    },
    async fetchData(filter, fetchUsers = false) {
      try {
        const filterClone = { ...filter };
        if (!filterClone?.cities || !filterClone?.cities?.length)
          delete filterClone?.cities;
        if (!filterClone?.type || filterClone?.type === "all")
          delete filterClone.type;

        await this.$store.dispatch("getOrganizer", {
          filter: filterClone,
          eventList: false
        });

        if (fetchUsers) await this.$store.dispatch("getAllUsers");
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async deleteOrganizer(id) {
      try {
        const isConfirmed = await this.$confirm(
          "Sind Sie sicher, dass sie dieses Element löschen möchten?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const result = await this.deleteOpLoc(id);
          if (result.status === 200) {
            await this.fetchData(this.filter);
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
          }
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    editItem(item, type) {
      if (type) this.editedItem.type = type;
      if (item) this.editedItem = _.cloneDeep({ ...item });
      if (!this.editedItem?.geo?.coordinates)
        this.editedItem.geo = {
          coordinates: ["", ""]
        };
      this.showDialog = true;
    },
    closeDialog() {
      this.editedItem = { ...defaultOpLoc };
      this.showDialog = false;
      if (this.editId) window.location.href = "/events/oplocs";
    },
    async save(closeDialog) {
      try {
        let response = null,
          successMessage;
        if (this.editedItem?.geo && !this.editedItem?.geo?.type)
          this.editedItem.geo.type = "Point";

        if (this.editedItem._id) {
          successMessage = "Element wurde erfolgreich aktualisiert";
          response = await this.updateOpLoc(this.editedItem);
        } else {
          successMessage = "Element wurde erfolgreich angelegt";
          response = await this.createOpLoc(this.editedItem);
        }

        if (response.status === 200 || response.status === 201) {
          if (!this.editedItem._id) this.editedItem = response?.data;
          await this.fetchData(this.filter);
          await this.$store.dispatch("createSuccess", successMessage);
        }

        if (closeDialog) this.closeDialog();
      } catch (error) {
        await this.$store.dispatch("createError", error);
        if (this.editId) window.location.href = "/events/oplocs";
      }
    }
  },
  computed: {
    oplocs() {
      return this.$store.state.oplocs;
    },
    count() {
      return this.$store.state.oplocCount;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    users() {
      return this.$store.state.users;
    },
    cities() {
      return this.$store.state.organizerCities;
    }
  },
  components: {
    EventOrganizerFilter,
    EventOrganizerListTable,
    EventOrganizerEditDialog
  }
};
